var map = {
	"./bi_logo.svg": 4557,
	"./protoss-carrier.jpg": 7478,
	"./protoss-mothership.jpg": 6935,
	"./protoss-nexus.jpg": 4543,
	"./protoss-observer.jpg": 6150,
	"./protoss-oracle.jpg": 7990,
	"./protoss-probe.jpg": 6032,
	"./protoss-sentry.jpg": 641,
	"./protoss-warp-prism.jpg": 4846,
	"./spear-of-adun.jpg": 3207,
	"./tianhua_logo.png": 893,
	"images/bi_logo.svg": 4557,
	"images/protoss-carrier.jpg": 7478,
	"images/protoss-mothership.jpg": 6935,
	"images/protoss-nexus.jpg": 4543,
	"images/protoss-observer.jpg": 6150,
	"images/protoss-oracle.jpg": 7990,
	"images/protoss-probe.jpg": 6032,
	"images/protoss-sentry.jpg": 641,
	"images/protoss-warp-prism.jpg": 4846,
	"images/spear-of-adun.jpg": 3207,
	"images/tianhua_logo.png": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3881;